import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import uniqueId from 'lodash.uniqueid';

import Grid from '@material-ui/core/Grid';

import { KeyboardDateTimePicker } from "@material-ui/pickers";

class RawDateTimeInput extends React.Component {
  constructor(props) {
    super(props);

    this.id = uniqueId();
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(datetime) {
    this.props.setValue(datetime);
  }

  render() {
    return (
      <Grid container className={ this.props.className }>
        <Grid item xs={12}>
          <KeyboardDateTimePicker
            label={ this.props.label }
            variant="inline"
            ampm={false}
            value={ this.props.getValue() }
            onChange={ this.changeValue }
            { ...this.props.elementProps }
          />
        </Grid>
      </Grid>
    );
  }
}

RawDateTimeInput.propTypes = {
  validForm: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default withFormsy(RawDateTimeInput);

